// global imports
import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';

// local imports
import PrivateRoute from 'app/components/home/PrivateRoute';
import { store, history } from 'app/redux/store';

// components
import Home from 'app/components/home/Home';
import Login from 'app/components/login/Login';
import WindowModal from 'app/components/home/windowModal/WindowModal';
import AlertBandContainer from 'app/components/commons/alertBand/AlertBandContainer';

function App() {
  return (
    <Provider store={store}>
      <Router history={history}>
        <Switch>
          <Route path='/login' component={Login} />
          <PrivateRoute path='/window-modal' component={WindowModal} />
          <PrivateRoute path='/' component={Home} />
        </Switch>
      </Router>
      <AlertBandContainer />
    </Provider>
  );
}

export default App;
